import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')       // Remove all non-word chars
    .replace(/--+/g, '-')           // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

export function formatRelativeTime(dateString: string, t?: any): string {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return t ? t('time.just_now', { defaultValue: 'just now' }) : 'just now';
  
  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) return t ? t('time.minutes_ago', { count: diffInMinutes, defaultValue: `${diffInMinutes}min` }) : `${diffInMinutes}min`;
  
  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) return t ? t('time.hours_ago', { count: diffInHours, defaultValue: `${diffInHours}Hrs` }) : `${diffInHours}Hrs`;
  
  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) return t ? t('time.days_ago', { count: diffInDays, defaultValue: `${diffInDays}D` }) : `${diffInDays}D`;
  
  const diffInMonths = Math.floor(diffInDays / 30);
  if (diffInMonths < 12) return t ? t('time.months_ago', { count: diffInMonths, defaultValue: `${diffInMonths}Mo` }) : `${diffInMonths}Mo`;

  const diffInYears = Math.floor(diffInDays / 365);
  return t ? t('time.years_ago', { count: diffInYears, defaultValue: `${diffInYears}Y` }) : `${diffInYears}Y`;
}